export default __webpack_public_path__ + "static/media/leftStar.eae5bf48.gif";